module.exports = __webpack_public_path__ + "img/007ef517-bafd-4066-aae4-6883632d9646.83d79eed.gif";